<template>
    <div class="qrcode" ref="qrCodeUrl"></div>
</template>

<script>
import {  QRCode  } from 'qrcodejs2'
export default{
    data(){
      return {
        
      }
    },
    methods:{
      creatQrCode(){
        var qrcode = new QRCode(this.$refs.qrCodeUrl,{
          text:'https://www.baidu.com',
          width:100,
          height:100,
          colorDark:'#000',
          colorLight:'#fff'
        })
      }
    },
    mounted() {
      this.creatQrCode();
    }
}
</script>

<style>
  .qrcode{
    display: inline-block;
    img{
      width: 132px;
      height: 132px;
      background-color: #ffffff;
      padding:6px;
      box-sizing:border-box;
    }
  }
</style>
